"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dependencies = void 0;
exports.dependencies = {
    mapper: {},
    decode: {},
    encode: {},
    repository: {},
    useCase: {},
    validator: {},
    controller: {},
};
//# sourceMappingURL=dependencies.js.map